import React from "react";
import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import { ROUTES } from "../configs/routes";
import { REQUEST_NUMBER } from "../constants/storage";
import { store } from "../store";
import { UtilsBrowser } from "../utils/UtilsBrowser";
import { Cookie } from "./storage";
import { AuthType } from "../types/auth";

const locationHelper = locationHelperBuilder({});

/**
 * Placeholder rendered while auth resolves.
 *
 * Deliberately dependency-free: this module sits in the store's import chain,
 * so importing the real Loading component would pull Lottie and its canvas
 * dependency into every consumer (and break them under jsdom).
 */
const AuthResolving = () =>
  React.createElement("div", { className: "loading-screen" });

export const nonAuth = connectedRouterRedirect({
  authenticatedSelector: () => {
    return !UtilsBrowser.isInternetExplorer();
  },
  redirectPath: (_, ownProps) => {
    return UtilsBrowser.isInternetExplorer()
      ? ROUTES.ERROR_IE
      : locationHelper.getRedirectQueryParam(ownProps) || ROUTES.ROOT;
  },
  wrapperDisplayName: "UserIsNotAuthenticated",
});

export const auth = connectedRouterRedirect({
  authenticatedSelector: (_, ownProps: any) => {
    const authState = store.getState().auth;
    const isLoggedIn = authState.isLoggedIn;

    // Cookie.remove(REQUEST_NUMBER);

    if (ownProps.match.params.requestNumber && !isLoggedIn) {
      Cookie.set(REQUEST_NUMBER, ownProps.match.params.requestNumber);
    }

    return isLoggedIn;
  },
  // Hold the route while auth is still resolving. Without this the guard reads
  // a not-yet-resolved "false" and bounces the user off the page they just
  // logged in to reach.
  authenticatingSelector: (state: any) => state.auth.status === "unknown",
  AuthenticatingComponent: AuthResolving,
  redirectPath: ROUTES.ROOT, // NOTE: Redirected back to home page so that user will be presented login options (email/SA)
  wrapperDisplayName: "UserIsAuthenticated",
});

/**
 * Role-based route guard. Use this for routes that require a specific auth type.
 * Example: authWithType("SA") for Samsung Account-only routes.
 */
export const authWithType = (requireType: AuthType) =>
  connectedRouterRedirect({
    authenticatedSelector: (_, ownProps: any) => {
      const authState = store.getState().auth;
      const isLoggedIn = authState.isLoggedIn && authState.type === requireType;

      if (ownProps.match.params.requestNumber && !isLoggedIn) {
        Cookie.set(REQUEST_NUMBER, ownProps.match.params.requestNumber);
      }

      return isLoggedIn;
    },
    authenticatingSelector: (state: any) => state.auth.status === "unknown",
    AuthenticatingComponent: AuthResolving,
    redirectPath: ROUTES.ROOT,
    wrapperDisplayName: `UserIsAuthenticatedWithType(${requireType})`,
  });

export const unsupportedBrowserOnly = connectedRouterRedirect({
  authenticatedSelector: () => {
    return UtilsBrowser.isInternetExplorer();
  },
  redirectPath: ROUTES.ROOT,
});
